import React from "react";

import {
    Box,
    Stepper as ChakraStepper,
    Stack,
    Step,
    StepDescription,
    StepIndicator,
    StepStatus,
    useSteps
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type PropTypes = {
    step?: number;
    isEnrol?: boolean;
    isAfterEnrolmentPathway?: boolean;
    isReEnrolmentPathway?: boolean;
};

const Stepper = ({
    step,
    isEnrol = false,
    isAfterEnrolmentPathway = false,
    isReEnrolmentPathway = false
}: PropTypes) => {
    let steps;
    const { t } = useTranslation();
    if (isAfterEnrolmentPathway) {
        steps = t(
            "stepper.afterEnrolmentPathway",
            "1. Subject selection, 2. Subject evaluation"
        ).split(",");
    } else if (isEnrol) {
        steps = t(
            "stepper.enrol",
            "1. Your details, 2. Set password, 3. Student enrolment"
        ).split(",");
    } else if (isReEnrolmentPathway) {
        steps = t(
            "stepper.reEnrol",
            "1. Enrolment, 2. Subject selection, 3. Subject evaluation"
        ).split(",");
    } else {
        steps = t(
            "stepper.checkout",
            "1. Your details, 2. Student details, 3. Enrolment details, 4. Payment"
        ).split(",");
    }

    const { activeStep } = useSteps({
        index: step ? step - 1 : 0,
        count: steps.length
    });

    return (
        <Box display={{ base: "none", md: "block" }}>
            <ChakraStepper size="xs" index={activeStep} gap={0} mb={8}>
                {steps.map((step, index) => (
                    <Step<React.ElementType>
                        key={step}
                        position="relative"
                        gap={0}
                        flexShrink={0}
                        _notFirst={{
                            _before: {
                                content: "''",
                                position: "absolute",
                                top: 2,
                                height: "1px",
                                width: "50%",
                                bg: "gray.300",
                                zIndex: steps.length === 2 ? 1 : -1
                            }
                        }}
                        _notLast={{
                            _after: {
                                content: "''",
                                position: "absolute",
                                top: 2,
                                right: 0,
                                height: "1px",
                                width: "50%",
                                bg: "gray.300",
                                zIndex: steps.length === 2 ? 1 : -1
                            }
                        }}
                    >
                        <Stack
                            align="center"
                            justify="flex-start"
                            pl={index !== 0 ? 3 : undefined}
                            pr={index !== steps.length - 1 ? 3 : undefined}
                        >
                            <StepIndicator>
                                <StepStatus />
                            </StepIndicator>
                            <StepDescription<React.ElementType>
                                fontFamily="secondary"
                                textAlign="center"
                                fontWeight={
                                    activeStep === index ? "600" : "400"
                                }
                                color={
                                    activeStep === index
                                        ? "gray.800"
                                        : "gray.600"
                                }
                            >
                                {step}
                            </StepDescription>
                        </Stack>
                    </Step>
                ))}
            </ChakraStepper>
        </Box>
    );
};

export default Stepper;
